module.exports = __webpack_public_path__ + "img/thriller.daf2485c.svg";